import { Component, Input, Output, OnInit, OnChanges, SimpleChanges, EventEmitter, inject, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { HisSearchResultComponent } from './his-search-result.component';
import { HisSearchResultRow } from '../model/his-search-result';
import { PaginatorState } from 'primeng/paginator';
import { ActivatedRoute, ParamMap } from '@angular/router';

@Component( {
    selector: 'his-search-result-list',
    templateUrl: './his-search-result-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchResultListComponent implements OnInit, OnChanges  {

    private route = inject(ActivatedRoute);
    
	
	@Input() hisSearchResultComponent: HisSearchResultComponent;

    @Input() data: HisSearchResultRow[];

    /** der Seitentilte als i18n key */
    @Input() pageTitle: string;
    
    @Input() imageTitle: string;

	@Input() first: number;

	@Input() records: number;

	@Input() rows: number;

    @Output() page = new EventEmitter();

    @Input() showNewSearchButton = true;
    @Input() showChangeSearchButton = true;
    @Input() showSwitchListToTableButton = true;
    @Input() showPaginator = true;
    @Input() showTableDataScroller = true;
    @Input() showResultRowsLimitedMessage = true;

    @Input() image = 'PUBLICATION';
    
    @Input() bannerTemplate?: TemplateRef<unknown>;

    private currentMode: string | null = null;

    currentPage: number;
    totalPage: number;
    rowsPerPage: number;

    ngOnInit() {
		
        // Direkt den ParamMap-Typ verwenden, so stimmt subscribe() automatisch
        this.route.queryParamMap.subscribe((params: ParamMap) => {
	      this.currentMode = params.get('mode');
	    });
		

	    if ( this.data.length === 0 ) {
		    this.hisSearchResultComponent.load( {} );
	    }
    }

    ngOnChanges( changes: SimpleChanges ) {
        if ( changes.data ) { // changes.data.currentValue is equal to @Input() data
            this.rowsPerPage = this.hisSearchResultComponent.rowsPerPage;
            // load additional attributes from backend
            let personIds: number[] = this.data.map( searchResultRow => parseInt( searchResultRow.get('Person.id'), 10 ) );
            if ( personIds.length > 0 ) {
                for ( let i = 0; i < personIds.length; i++ ) {

                    let searchResultRow = this.data[i];
                    searchResultRow.set( 'Person.id', personIds[i] );
                }
            }

            this.totalPage = ( ( this.records - ( this.records % this.rowsPerPage ) ) / this.rowsPerPage ) + 1;
            this.currentPage = ( this.first / this.rowsPerPage ) + 1;
        }
    }

    /**
    * service must not be called without "Login"
    *
    * @param auth includes all right
    */
    switchListTable() {
        this.hisSearchResultComponent.switchListTable();
    }

    /**
    * Page change function of PrimeNG
    *
    * @param event.pageCount Total number of pages
    * @param event.page  Index of the new page
    * @param event.first Index of the first record
    */
    paginate( event: PaginatorState ) {
        this.page.emit( event );
    }

}
